module.exports = __webpack_public_path__ + "static/media/mbook.9f56a55e.jpg";